export function isSuperAdmin(email: string | undefined): boolean {
  if (!email) return false;
  const re = /^(?:andy|guy|jk|larry|nam|rachel|rzp|admin)@sudozi\.com$/;
  return re.test(email);
}
